
export default function KeyAreasEvaluated() {
  const areas = [
    {
      icon: 'ri-shield-user-line',
      title: 'Access Management & Identity Security',
      color: 'from-[#e10708] to-[#c00607]',
      items: [
        'Use of Multi-Factor Authentication (MFA) on email systems',
        'MFA on remote access (VPN, cloud apps)',
        'MFA on administrative and privileged accounts',
        'Role-based access and least-privilege enforcement'
      ]
    },
    {
      icon: 'ri-database-2-line',
      title: 'Data Protection & Backups',
      color: 'from-[#c00607] to-[#a00506]',
      items: [
        'Regularly scheduled backups',
        'Encryption of backup data',
        'Off-site or immutable backups to protect against ransomware',
        'Documented backup testing and restore validation'
      ]
    },
    {
      icon: 'ri-radar-line',
      title: 'Security Controls & Monitoring',
      color: 'from-[#a00506] to-[#e10708]',
      items: [
        'Endpoint Detection & Response (EDR)',
        'Firewalls and network security controls',
        'Email security and anti-phishing protections',
        'Continuous monitoring or managed security services'
      ]
    },
    {
      icon: 'ri-file-list-3-line',
      title: 'Policies, Procedures & Employee Training',
      color: 'from-[#e10708] to-[#c00607]',
      items: [
        'Ongoing security awareness training',
        'Phishing simulations or testing',
        'A documented incident response plan',
        'Defined roles and escalation paths during a cyber event'
      ]
    },
    {
      icon: 'ri-links-line',
      title: 'Vendor & Third-Party Risk Management',
      color: 'from-[#c00607] to-[#a00506]',
      items: [
        'Security requirements for vendors with system or data access',
        'Business Associate Agreements (BAAs) where applicable',
        'Monitoring and review of third-party security practices'
      ]
    }
  ];

  return (
    <section className="py-20 px-6 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Key Areas Insurers Evaluate
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Cyber insurers typically assess the following areas to understand your risk profile
          </p>
        </div>

        <div className="space-y-6">
          {areas.map((area, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl p-8 shadow-lg border border-gray-200 hover:shadow-xl transition-all"
            >
              <div className="flex items-start gap-6">
                <div className={`flex-shrink-0 w-16 h-16 bg-gradient-to-br ${area.color} rounded-xl flex items-center justify-center`}>
                  <i className={`${area.icon} text-3xl text-white`}></i>
                </div>
                
                <div className="flex-1">
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">
                    {index + 1}. {area.title}
                  </h3>
                  
                  <ul className="space-y-3">
                    {area.items.map((item, idx) => (
                      <li key={idx} className="flex items-start gap-3">
                        <i className="ri-checkbox-circle-fill text-[#e10708] text-xl flex-shrink-0 mt-0.5"></i>
                        <span className="text-gray-700 leading-relaxed">{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}